import React from 'react';
import { Card, Field, TextInput, PrefixInput, T, GenderField, HandleField } from '../fields';
import { OCCUPATION_MAX, socialHandle } from '../../../utils/portalPageModel';

/*
 * THE BASICS — name, handle, LOCATION + INSTAGRAM and WHAT YOU DO + TIKTOK two-up on desktop,
 * GENDER pills and "Hide gender on my page". The occupation and the two handles are what
 * sign-up v3's YOU strip asked (Oct 22 2026); this is where they are edited afterwards. Every field is the shared Portal field kit (`components/profile/
 * fields`), the same one Onboarding v2's step 1 renders, and the handle rule is the one in
 * `utils/portalPageModel`. `handleState` is the live availability check.
 */
export default function BasicsTab({ d, upd, phone, handleState, handleOptions = [] }) {
  return (
    <Card phone={phone} data-testid="basics-card" style={{ gap: 18 }}>
      <span style={T.title}>IDENTITY</span>
      <Field label="NAME">
        <TextInput value={d.name} onChange={(v) => upd({ name: v })} maxLength={60} autoComplete="name" data-testid="name-input" />
      </Field>
      <HandleField value={d.handle} onChange={(v) => upd({ handle: v })} status={handleState} variant="error" />
      {handleOptions.length > 0 && (
        <div role="group" aria-label="Handle suggestions" style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: -8 }}>
          {handleOptions.map((h) => (
            <button key={h} type="button" aria-pressed={d.handle === h} onClick={() => upd({ handle: h })} data-testid="handle-option"
              style={{ height: 34, padding: '0 14px', border: 0, borderRadius: 999, background: d.handle === h ? '#fff' : '#1F1F1F', color: d.handle === h ? '#000' : '#fff', fontFamily: 'inherit', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>
              {h}
            </button>
          ))}
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: phone ? 'minmax(0,1fr)' : 'repeat(2,minmax(0,1fr))', gap: 14 }}>
        <Field label="LOCATION">
          <TextInput value={d.location} onChange={(v) => upd({ location: v })} placeholder="Town or city" maxLength={100} data-testid="location-input" />
        </Field>
        <Field label="INSTAGRAM">
          <PrefixInput prefix="@" value={d.instagram} onChange={(v) => upd({ instagram: v.replace(/^@/, '').replace(/\s/g, '') })} placeholder="handle" maxLength={60} autoCapitalize="none" autoCorrect="off" spellCheck={false} data-testid="instagram-input" />
        </Field>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: phone ? 'minmax(0,1fr)' : 'repeat(2,minmax(0,1fr))', gap: 14 }}>
        <Field label="WHAT YOU DO" hint="One short line. Reads under your name.">
          <TextInput value={d.occupation || ''} onChange={(v) => upd({ occupation: v.slice(0, OCCUPATION_MAX) })} placeholder="Winemaker · nurse · builds things" maxLength={OCCUPATION_MAX} autoComplete="organization-title" data-testid="occupation-input" />
        </Field>
        <Field label="TIKTOK">
          <PrefixInput prefix="@" value={d.tiktok || ''} onChange={(v) => upd({ tiktok: socialHandle(v) })} placeholder="handle or profile link" autoCapitalize="none" autoCorrect="off" spellCheck={false} data-testid="tiktok-input" />
        </Field>
      </div>
      <GenderField
        value={d.gender}
        onChange={(gender) => upd({ gender })}
        hidden={d.genderHidden}
        onToggleHidden={() => upd({ genderHidden: !d.genderHidden })}
      />
    </Card>
  );
}
